
<v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
        <a
            v-bind = "attrs"
            v-on   = "on"
            class  = "audit-menu"
        >
            <v-icon color="white" size="24">mdi-menu</v-icon>
        </a>
    </template>

    <div class="white">
        <v-list class="white">
            <v-list-item
                v-for = "(entry, index) in menu"
                :key  = "index"
                link
            >
                <v-list-item-title
                    @click = "onCategory(entry)"
                >
                    {{ entry.name }}
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</v-menu>
